/**
 * Subscriber.js
 * File cloned from account/Account.js and modified
 */
import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import { Button, Grid } from '@material-ui/core';
import { AgGridReact } from 'ag-grid-react';
import { withSnackbar } from 'notistack';
import { WebClientStore } from 'web-client-store';

import LoadingOverlay from 'components/common/loadingOverlay';
import mapStateToProps from 'reducers/actions/stateToProps';
import mapDispatchToProps from 'reducers/actions/dispatchProps';
import Constants from 'components/utils/constants';
import { AccountHandler, ListItemHandler } from 'chits-data/dist';
import { SubscriberHandler } from 'chits-data/dist';

import './Subscriber.css';
import NewSubscriber from './NewSubscriber';
import { SubscriberGrid } from './SubscriberGrid';
import { SubscriberStyle } from './SubscriberStyle';
import { formatSubcriberName } from 'components/mapper/objectMapping';

let defaultMode = Constants.ACTIVE_SUBSCRIBER_GRID_MODES.LIGHT;
let {Local, Session} = WebClientStore;
class Subscriber extends React.Component {
    
    constructor(props) {
        super(props);
        this._handler = new SubscriberHandler();
        this._handlerListItems = new ListItemHandler();
        this._handlerAccount = new AccountHandler();
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.handleResetAllFilters = this.handleResetAllFilters.bind(this)
        this.onSelectionChanged = this.onSelectionChanged.bind(this)
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    updateWindowDimensions() {
        this.setState({ 
            width: window.innerWidth, 
            height: window.innerHeight,
        });
    }

    getDefaultMode = ()=>{
        let key = Constants.LOCAL_KEYS.ACTIVE_SUBSCRIBER_GRID_MODE;
        if (Local.get(key)) {
            return Number(Local.get(key))
        } else {
            Local.set(key, defaultMode);
        }
        return defaultMode;
    }

    handleSetMode = (gridMode=defaultMode) => {
        let key = Constants.LOCAL_KEYS.ACTIVE_SUBSCRIBER_GRID_MODE;
        Local.set(key, gridMode);
        this.setState({gridMode, enabledUpdate: false})
    }

    state = {
        width: 0,
        height: 0,
        openOverlay: false,
        subscribers: [],
        filteredAccounts: [],
        enableAdd: false,
        enableAddChitInfo: false,
        enabledUpdate: false,
        showUpdateModal: false,
        typeMap: {'SUB': 'Subscriber Account'},
        accountTypes: [],
        searchTerm: '',
        accountFilterType: 'show_all',
        selectedAccount: { _id: 'unkonwn' },
        rowsSelected: {},
        gridMode: this.getDefaultMode(),
        newAccount: {},
        clearCache: this.props.appState.clearCache
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        let ac = this._handlerAccount.getActiveAccount();
        // // asynchronously load account information to props
        this._handlerAccount.getAccountCached(ac).then((account) => {
          if (account) this.props.setCurrentAccount(account);
        })
        .finally(()=>{
          this.handleGetSubscribers();
        })
    }
      
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
    
    handleSearchChange = (e) => this.filterAccounts(e.target.value);
    handleResetAllFilters = () => this.filterAccounts('')
    filterAccounts = (query) => {
        let _subscribers = this.state.subscribers;
        try {
            let _filtered = _subscribers.filter((ac)=>{
                return ac.name?.toLowerCase().includes(query.toLowerCase()) ||
                ac.code?.toLowerCase().includes(query.toLowerCase());
            })
            this.setState({
                searchTerm: query,
                filteredAccounts: (query === '' ? _subscribers : _filtered)
            })
        } catch (error) {
            console.error(error);
        }
    }

    handleReActivateAccount = (acId) => {
        this._handler.unArchiveSubscriber(acId).then(()=>{
            this.handleGetSubscribers(true);
        })
    }

    handleFilterAccounts = (type='') => {
        let _searchTerm = this.state.searchTerm;
        let _subscribers = this.state.subscribers.filter(ac=>(ac.status==='ac'));
        let _filtered = _subscribers.filter(ac=>(ac.type === type && ac.status === 'ac'))
        this.setState({
            searchTerm: (type === '' ? '' : _searchTerm),
            filteredAccounts: (type === '' ? _subscribers : _filtered),
            accountFilterType: (type === '' ? 'show_all' : type)
        })
    }

    handleFilterAccountsSharedOnly = () => {
        let _subscribers = this.state.subscribers;
        let _filtered = _subscribers.filter(ac=>!ac.isOwner)
        this.setState({
            filteredAccounts: _filtered,
            accountFilterType: 'shared'
        })
    }

    handleFilterAccountsArchivedOnly = () => {
        let _subscribers = this.state.subscribers;
        let _filtered = _subscribers.filter(ac=> (ac.status === 'cl'))
        this.setState({
            filteredAccounts: _filtered,
            accountFilterType: 'archive'
        })
    }

	handleGetSubscribers = async (refresh=false) => {
        this.setState({ openOverlay: true });
        let _type = 'error';
        let _msg = '';
        let _subscribers = this.state.subscribers;
        let _clearCache = refresh || this.state.clearCache;
        //dummy initialize a promise to start conditional execution.
        let request = Promise.resolve(_clearCache);
        request
            .then((condition)=>{
                return this._handler.getSubscribersCached(condition);
            })
            .then((data) => {
                // console.log(data);
                _subscribers = data;
            })
            .catch((err) => {
                console.error('error while fetching subscribers:' + err.message);
                _msg = err.message;
                _type = err.type;
            })
            .finally(()=>{
                if (_type === 'timeout') {
                    this.props.enqueueSnackbar(_msg, { variant: 'error'})
                    this.props.history.push('/logout');
                }
                this.setState({
                    openOverlay: false, 
                    subscribers: _subscribers,
                    filteredAccounts: _subscribers.filter(ac=>(ac.status==='ac')),
                    clearCache: false
                })
            });
    }

    
    render() {
        //TODO: Move all front page's card-header styles to a central location
        // also render cardHeader as a component.
        let _modes = Constants.ACTIVE_SUBSCRIBER_GRID_MODES;
        return (
          <div className="content-fluid">
             <div className="row">
              <div className="col-ms-12 mx-auto" >
                <div className="card">
                  <div className="card-header"
                  style={{ paddingLeft: '1em', paddingRight: '1em', paddingTop: '1em', textAlign: 'center'}}
                  >
                    <h4 className="card-title">Your Contacts</h4>
                    {/* <p className="card-category"
                        style={{ color: '#9C27B0', fontWeight: '500' }}
                    >{this.props.wallet.current.name}</p> */}
                    {this.renderNewAccountAction()}
                  </div>
                  <div className="card-body">
                    {/* {this.renderToolBar()} */}
                    {this.state.subscribers.length > 0 && this.state.gridMode !== _modes.CARDS && this.renderAGGrid()}
                    {this.state.enableAdd && this.renderNewAccountForm()}
                    {/* {this.state.enableEdit && this.renderEditAccountForm()} */}
                    {/* {this.state.enableAddChitInfo && this.renderNewAccountChitInfoForm()} */}
                    {this.state.showUpdateModal && this.renderUpdateAccountForm()}
                    {this.state.openOverlay && <LoadingOverlay />}
                  </div>
                </div>
              </div>
             </div>
           </div>
        )
    }


    renderNewAccountAction() {
        return (
            <Grid container id="trans-actions">
                <Grid item md={12} sm={12} xs={12} id="trans-actions-left">
                    <Button onClick={() => this.setState({ enableAdd: true })}
                        variant="contained"
                        size="large"
                        style={{float: "right"}}
                        color="primary">
                        Add
                    </Button>
                    {this.state.enabledUpdate &&
                        <Button onClick={() => this.setState({ showUpdateModal: true })}
                            variant="contained"
                            size="large"
                            style={{float: "right"}}
                            color="inherit">
                            Edit
                    </Button>}
                </Grid>
            </Grid>
        )
    }
    
    renderToolBar() {
        return (
            <Grid container id="trans-actions">
                <Grid item md={12} sm={12} xs={12}>
                    <input id="quickSearch" type="name" placeholder="Search here"
                        value={this.state.searchTerm}
                        style={{maxWidth: 200, marginLeft: '0.6em'}}
                        onChange={this.handleSearchChange} />
                    {this.state.searchTerm !== '' && <label forhtml="quickSearch"><span 
                        onClick={() => this.handleResetAllFilters()}
                        ><i className="pe-7s-close" style={{fontSize: 32, fontWeight: "bolder"}}></i></span>
                        </label>}
                </Grid>
            </Grid>
        )
    }

	handleOnGridReady = params => {
        this.gridApi = params.api;
    }

	onSelectionChanged() {
		let flagUpdate = false;
		let selectedRows = this.gridApi.getSelectedRows();
		let oneRow = selectedRows[0];
		if (oneRow && oneRow._id && oneRow._id !== '') {
			//proceed
		} else {
			return;
		}
		flagUpdate = selectedRows.length === 1;
		//extract account info from session and pass it to selecteAccount
        window.sendNativeNotification("Subscriber selected:" + formatSubcriberName(oneRow) + " with id: " + oneRow._id);
        this._handler.getSubscriberCached(oneRow._id).then((account)=>{
            // console.log('subscriber->getAccountCache', account)
            this.setState({ 
                rowsSelected: oneRow, 
                enabledUpdate: flagUpdate,
                selectedAccount: account
            })
        })
        
    }
    
    renderAGGrid() {
        const { classes } = this.props;
        let _modes = Constants.ACTIVE_SUBSCRIBER_GRID_MODES;
        let gridDef = SubscriberGrid(this.state.width);
        const agStyles = `ag-theme-${this.state.gridMode === _modes.DARK ? 'alpine-dark' : 'balham'} ${classes.agThemeModified}`;
        return (
			<Grid container id='sub-subscribers-grid'   >
				<Grid item  md={12} sm={12} xs={12}>
					<div className={agStyles}>
						<AgGridReact
							gridOptions={{
								defaultColDef: {
                                    resizable: true,
                                    sortable: true,
                                    cellStyle: { fontSize: '1.0em'},
								}
							}}
							// onRowDragEnter={this.onRowDragEnter}
							// onRowDragEnd={this.onRowDragEnd}
							onGridReady={this.handleOnGridReady}
							// onRowDragLeave={this.onRowDragLeave}
							columnDefs={gridDef}
							rowData={this.state.filteredAccounts}
							// getRowClass={this.handleRowHighlights}
							rowSelection="single"
							onSelectionChanged={this.onSelectionChanged.bind(this)}
							// rowDragManaged={true}
							animateRows
							// pagination={!this.state.gridEditMode}
                            // paginationPageSize={25}
                            enableCellTextSelection="true"
                            ensureDomOrder="true"
						/>
					</div>
				</Grid>
			</Grid>
        );
    }

    renderNewAccountForm() {
        return (
            <NewSubscriber 
                display={this.state.enableAdd}
                onCancel={() => {
                    this.setState({ enableAdd: false });
                }} 
                onSubmit={() => {
                    this.setState({ enableAdd: false });
                    this.handleGetSubscribers(true);
                }} 
                // onInitChitInfo={(newAccount) => {
                //     this.setState({
                //         newAccount,
                //         enableAdd: false,
                //         enableAddChitInfo: true
                //     })
                // }}
                modeUpdate={false}
                asDialog={true}
                account={{}}
            />
        )
    }
    
    renderUpdateAccountForm() {
        return (
            <NewSubscriber 
                display={this.state.showUpdateModal}
                onCancel={() => {
                    this.setState({ showUpdateModal: false });
                }} 
                onSubmit={() => {
                    this.setState({ showUpdateModal: false, enabledUpdate: false });
                    Session.set('force_refresh', true)
                    this.handleGetSubscribers(true);
                }} 
                modeUpdate={true}
                asDialog={true}
                account={this.state.rowsSelected}
            />
        )
    }

}

Subscriber.propTypes = {
    classes: PropTypes.object.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(withStyles(SubscriberStyle)(Subscriber)));
